/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PacienteEncuestaRespuestaModelDto } from '../../models/paciente-encuesta-respuesta-model-dto';

export interface DoctorEncuestasControllerObtenerRespuestasEncuesta$Params {

/**
 * UUID del paciente para obtener sus respuestas de encuesta
 */
  uuidPaciente: string;

/**
 * UUID de la encuesta para obtener sus respuestas
 */
  uuidEncuesta: string;
}

export function doctorEncuestasControllerObtenerRespuestasEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerObtenerRespuestasEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<PacienteEncuestaRespuestaModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerRespuestasEncuesta.PATH, 'get');
  if (params) {
    rb.path('uuidPaciente', params.uuidPaciente, {});
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PacienteEncuestaRespuestaModelDto>;
    })
  );
}

doctorEncuestasControllerObtenerRespuestasEncuesta.PATH = '/api/doctor-encuestas/obtener-respuestas-paciente/{uuidPaciente}/{uuidEncuesta}';
